import { render, staticRenderFns } from "./schemas.page.vue?vue&type=template&id=5e13c728&scoped=true&"
import script from "./schemas.page.vue?vue&type=script&lang=js&"
export * from "./schemas.page.vue?vue&type=script&lang=js&"
import style0 from "./schemas.page.vue?vue&type=style&index=0&id=5e13c728&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e13c728",
  null
  
)

export default component.exports